<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ADD REGIONAIS ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <vs-list-item title="Selecionar Todos">
        <div class="flex justify-start mr-2">
          <vs-checkbox v-model="selecionarTodasRegionais" />
        </div>
      </vs-list-item>
      <vs-list>
        <vs-list-item
          v-for="item in regionais"
          :key="item.id_regional"
          :title="`${item.nome}${item.deletedAt ? ' (INATIVA)' : ''}`"
          :subtitle="`${item.cidade} - ${item.estado}}`"
        >
          <vs-checkbox
            v-model="item.selected"
            :checked="selecionarTodasRegionais"
          />
        </vs-list-item>
      </vs-list>

      <!-- botões de cancelar salvar -->
      <div class="vx-row mb-5">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2 mt-3"
            @click="emitirClose()"
            >Cancelar</vs-button
          >
          <vs-button color="success" type="gradient" class="mr-3 mb-2 mt-3"
            >Salvar Alterações</vs-button
          >
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import 'vue-select/dist/vue-select.css';
import service from '../../services';
import { VMoney } from 'v-money';
import jwt from 'jsonwebtoken';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    selecionarTodasRegionais() {
      this.regionais.map((regionais) => {
        this.selecionarTodasRegionais
          ? (regionais.selected = true)
          : (regionais.selected = false);
      });
    },
    /*regionais(value) {
      if (value.length != 0) {
        if (this.formCadastro.isValorFixo == true)
          this.activePromptValor = true;
        else this.adicionaRegional();
      }
    },*/
    dados() {
      this.buscaDadosSelects('regionais', 'regionais', 'nome', 'idRegional');
    },
  },
  data() {
    return {
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
      },
      passo: 0,
      activePromptValor: false,
      aguardeCadastro: false,
      valorGrupo: 0.0,
      idEmpresa: null,
      grupos: [],
      modalForm: false,
      gruposVeiculos: [],
      regionaisUsuario: [],
      regionaisDefault: [],
      formasPagamentos: [],
      destinos: ['Veículo', 'Associado', 'Dependente'],
      formaPagamento: null,
      languages: lang,
      fornecedores: [],
      fornecedoresFiltred: [],
      tipoProdutos: [],
      itemsPerPage: 10,
      selected: [],
      regionais: [],
      usuarios_regionais: [],
      objRegionais: [],
      modal: false,
      confirmar: false,
      formRegional: {
        estado: null,
        cidade: null,
        id_usuario_regional: null,
      },
      funcoesValicao: null,
      formCadastro: {
        idEmpresa: null,
        isValorFixo: true,
        isMensal: null,
        status: true,
        nomeProduto: '',
        obrigatorio: null,
        formasPagamentos: null,
        grupos: null,
        porcentagemDescontoMaxima: null,
        visivelProposta: null,
        produtoVisivel: 1,
        destinos: [],
        regional: null,
      },
      selecionarTodasRegionais: null,
    };
  },
  directives: { money: VMoney },
  methods: {
    selecionaTipo() {
      this.formCadastro.idFornecedor = null;

      if (this.formCadastro.idTipoProduto == 8) {
        this.formCadastro.isDesconto = true;
      } else {
        this.formCadastro.isDesconto = false;
      }
      this.fornecedoresFiltred = this.fornecedores.filter(
        (x) => x.idTipoProduto == this.formCadastro.idTipoProduto,
      );
    },
    exibeValor(valor) {
      var retorno =
        this.formCadastro.isValorFixo == true
          ? this.$options.filters.currency(valor)
          : 'Valor a ser definido na tabela';
      return retorno;
    },
    emitirClose() {
      this.$emit('close');
      this.resetForm();
    },
    preencheGrupo() {
      if (this.grupo.length == 0) {
        return '';
      } else {
        return this.grupo.label;
      }
    },
    resetForm() {
      this.formCadastro = {
        status: true,
        nome: '',
        consultor: false,
        podeFazerVistoria: false,
        email: '',
        cpf: '',
        celular: '',
        telefone: '',
        dataNascimento: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        pais: 'Brasil',
        idSetor: '',
        idPerfil: '',
        idRegional: '',
        senha: '',
        userName: '',
        regionais: '',
      };
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service
        .getAll(
          'g',
          {},
          `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}?deleted=false`,
        )
        .then((res) => {
          this.regionais = [];
          res.data.forEach((element) => {
            if (element.isRegionalModel) {
              return;
            }

            var aux = null;

            if (this.dados.regionaisUsuarios) {
              aux = this.dados.regionaisUsuarios.find(
                (x) => x.id_regional == element[campoPK] && x.deletedAt == null,
              );
            }
            if (this.dados.regionaisVistoriadores) {
              aux = this.dados.regionaisVistoriadores.find(
                (x) => x.id_regional == element[campoPK] && x.deletedAt == null,
              );
            }

            if (element[campoPK] != this.dados.idRegional) {
              this.regionais.push({
                id_regional: element[campoPK],
                nome: element[campoDescricao],
                estado: element.estado,
                cidade: element.cidade,
                selected: aux ? true : false,
                deletedAt: element.deletedAt,
              });
            }

            // this.dados.regionaisUsuarios.forEach((elementSel) => {
            //     if(elementSel.id_regional == this.dados.idRegional){
            //     }

            // })
          });
        });
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    fecharPopup() {
      this.$emit('close', this.objRegionais);
    },
    onSubmit() {
      this.regionais.forEach((element) =>
        this.regionaisUsuario.forEach((elementSel) => {
          if (element.id_regional == elementSel.id) {
            element.selected = true;
          }
        }),
      );

      this.objRegionais = this.regionais;
      this.selected = this.regionais;
      this.fecharPopup();
    },
    clearFormGrupo() {
      this.activePromptValor = false;
      this.regionais = [];
    },
    closeModais() {
      this.modal = false;
    },
    onReset() {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        this.resetForm();
        this.$nextTick(() => {
          this.show = false;
        });
      }
    },
    convertSelectData(data) {
      data = data === null ? '' : data;

      const hasData = data.length;
      const dataType = typeof data;
      if (hasData && dataType === 'string') return data.split(',');

      if (Array.isArray(data)) return data.join(',');

      return data;
    },
  },
  mounted() {
    this.getDecoded();
    this.$validator.localize('ptBr', locale);
  },
  created() {},
  components: {},
};
</script>
<!------------ END SCRIPT ------------>

<style scoped>
.div-show {
  display: 'block';
}

.div-hide {
  display: none;
}

li.activeChild {
  border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
}

div.firstInputTab {
  margin-top: 20px;
}
</style>
